module.exports = __webpack_public_path__ + "src/assets/donate@1.5x-100.jpg";